// extracted by mini-css-extract-plugin
export default {"container":"NoResults_container__BKaqV"};